import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found-page">
      {/* Background Effects */}
      <div className="glow glow-1"></div>
      <div className="glow glow-2"></div>

      <div className="not-found-card">
        <div className="error-code">404</div>

        <div className="divider"></div>

        <h1>Page Not Found</h1>

        <p>
          Oops! The page you're looking for doesn't exist or may have been moved
          to another location.
        </p>

        <div className="not-found-actions">
          <button className="back-btn" onClick={() => window.history.back()}>
            ← Go Back
          </button>

          <Link to="/" className="home-btn">
            Go Home <span>→</span>
          </Link>
        </div>

        <div className="error-footer">
          <span className="status-dot"></span>
          <span>Error 404 • Page unavailable</span>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
